export default __webpack_public_path__ + "static/building-resilient-infrastructure-for-seamless-customer-service-delivery-cf79b79b8218bd3e9499e4a285422121.png";